import { supabase } from "@/integrations/supabase/client";
import { isSupabaseUnavailableError } from "@/lib/supabase-compat";

export async function fetchTaskPreview(id: string, organizationId: string) {
  const { data: task, error } = await supabase.from("tasks").select("*")
    .eq("id", id).eq("organization_id", organizationId).single();
  if (error) {
    if (isSupabaseUnavailableError(error)) return null;
    throw error;
  }
  if (!task.assignee_id) return { ...task, assignee: null };
  // tasks.assignee_id is auth.users.id, not people.id.
  const { data: assignee, error: assigneeError } = await supabase.from("people")
    .select("first_name, last_name").eq("user_id", task.assignee_id)
    .eq("organization_id", organizationId).is("deleted_at", null).maybeSingle();
  if (assigneeError) throw assigneeError;
  return { ...task, assignee };
}

export async function fetchContributionPreview(id: string, organizationId: string) {
  const { data, error } = await supabase.from("contributions")
    .select("*, person:people(first_name, last_name), allocations(amount, fund:funds(name))")
    .eq("id", id).eq("organization_id", organizationId).single();
  if (error) {
    if (isSupabaseUnavailableError(error)) return null;
    throw error;
  }
  return data;
}
